import { TenantCore } from "./tenants";

export enum FieldTypes {
  boolean = "boolean",
  email = "email",
  string = "string",
  text = "text",
  choice = "choice",
  multiple_choice = "multiple_choice",
  date = "date",
  time = "time",
  datetime = "datetime",
  duration = "duration",
  file = "file",
  image = "image",
  integer = "integer",
  float = "float",
  ip_address = "ip_address",
  url = "url",
  signature = "signature",
  canvas = "canvas",
}

export type FieldType = keyof typeof FieldTypes;

export interface Form {
  name: string;
  tenants: TenantCore[];
  _id: string;
  active: boolean;
  fields: FormField[];
}

export interface FormFields {
  name: string;
  fields: FormField[];
}

export interface FormCore extends Omit<Form, "fields"> {}

export interface FormFieldOption {
  text: string;
  value: string;
  order: number;
}

export interface FormField {
  name: string;
  fieldType: FieldType;
  required: boolean;
  pdfVisible: boolean;
  order: number;
  prefix?: string;
  sufix?: string;
  help_text?: string;
  default?: string;
  options?: FormFieldOption[];
  _id: string;
  formId: string;
  answers?: string[];
  relatedAttribute?: string;
  isDeviceId?: boolean;
}

export type RenderType =
  | "input"
  | "checkbox"
  | "canvas"
  | "select"
  | "radio"
  | "date"
  | "datetime"
  | "time"
  | "textarea";

export interface FormFieldSettings {
  prefix: boolean;
  sufix: boolean;
  help_text: boolean;
  default: boolean;
  options: boolean;
  renderType: RenderType;
  inputType?: "text" | "number" | "email" | "select";
  relatedAttribute?: boolean;
  isDeviceId: boolean;
}

export interface FormRequest extends Pick<Form, "name"> {
  active?: boolean;
  tenants: string[];
}

export interface FormRequestTouched {
  nameTouched: boolean;
}

export interface FormFieldRequest extends Omit<FormField, "_id" | "formId"> {
  active?: boolean;
}

export interface FormFieldRequestTouched {
  nameTouched: boolean;
  fieldTypeTouched: boolean;
  orderTouched: boolean;
}
